import { Trash2 } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionDelete(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {permission?.some(val => val.sub_action_name === route_name) &&
                <Trash2 size={16} className='action_btn text-danger me-3'
                    onClick={onClick}
                    data-tooltip-id='del'
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                />
            }

            <Tooltip id='del' className='bg-danger tooltip_msg' />
        </>
    )
}
